/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<script>
// 定数ファイル読み込み
import {MAX_CODE_DEFAULT} from 'js/const/constants';
import {MIN_CODE_DEFAULT} from 'js/const/constants';
/**
 * 検索条件コンポーネントの共通処理
 * @vuedoc
 * @exports js/common/ifSearch
 */
export default {
	props:{
		'r_messages': {
			type:Object,
			required: true,
		},
		'r_settings': {
			type:Object,
			required: true,
		},
		'r_default': {
			type:Object,
			default: function(){return {};}
		},
		'r_default_name': {
			type:Number,
			default: 100,
		},
		'r_disp': {
			type:Object,
			default: function(){return {};}
		},
		'r_is_search_disable':false,
	},
	computed: {
		code_max: function (){
			if ( this.r_default == null  || this.r_default.code_max == null) {
				return MAX_CODE_DEFAULT;
			}
			return this.r_default.code_max;
		},
		code_min: function (){
			if ( this.r_default == null || this.r_default.code_min  == null ) {
				return MIN_CODE_DEFAULT;
			}
			return this.r_default.code_min;
		},
		disp_btnSearch: function (){
			if ( this.r_disp == null || this.r_disp.btnSearch  == null ) {
				return true;
			}
			return this.r_disp.btnSearch;
		},
		disp_btnReset: function (){
			if ( this.r_disp == null || this.r_disp.btnReset  == null ) {
				return true;
			}
			return this.r_disp.btnReset;
		},
		is_search_disable:function(){
			return this.r_is_search_disable;
		}
	},
	methods: {
			//! オーバーライドして処理を記載
			clear:function(){
			},
			search:function(isSearchBtn=false){
				if(this.is_search_disable)return;

				var param = this.getSearchParam();
				this.$emit("event_search",param,isSearchBtn);
			},
			//! 現在の検索パラメータを取得 オーバーライドして処理を記載
			//! ※ 上位から呼ぶので必須
			getSearchParam: function(){
				return {};
			},
			/**
 			 * クリアボタンイベント
			 */
			onBtnReset: function(){
				this.clear();
				this.$emit("event_clear");
			},
			/**
			 * 検索イベント
			 */
			onBtnSearch: function(){
				if (this.validate()) {
					this.search(true);
				}
			},
			//! 現在の検索パラメータをチェックする オーバーライドして処理を記載
			//! ※ 上位から呼ぶので必須
			validate: function(){
				return true;
			},
			setDepart:function(){
			},
			/**
			 * 変換値取得
			 */
			getConvertSearchValue: function(type, value) {
				var result = null;

				switch (type) {
					// コードFROM-TO (数値)
					case 'numeric_from_to':
						result = $.extend(true, {}, value);
						// FROM-TO 入力
						if (value.from.length > 0 && value.to.length > 0) {
							var re = new RegExp(/^[0-9]*$/);
							if (re.exec(value.from) && re.exec(value.to)) {
								result.from = value.from;
								result.to = value.to;
							} else {
								result.from = '0';
								result.to = '0';
							}
						// FROM 入力
						} else if (value.from.length > 0 && value.to.length <= 0) {
							var re = new RegExp(/^[0-9]*$/);
							if (re.exec(value.from)) {
								result.from = value.from;
								result.to = '';
							} else {
								result.from = '0';
								result.to = '0';
							}
						// TO 入力
						} else if (value.from.length <= 0 && value.to.length > 0) {
							var re = new RegExp(/^[0-9]*$/);
							if (re.exec(value.to)) {
								result.from = '';
								result.to = value.to;
							} else {
								result.from = '0';
								result.to = '0';
							}
						}
						break;
					// その他
					default:
						break;
				}

				return result;
			},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/ifSearch.mixin.vue